import * as _ from "lodash";
import { GeoPoint } from "./geoPoint";

export class GeoBoundingBox {
    constructor(public minLatitude: number, public maxLatitude: number,
                public minLongitude: number, public maxLongitude: number) {
    }

    get center(): GeoPoint {
        return new GeoPoint((this.minLatitude + this.maxLatitude) / 2,
                            (this.minLongitude + this.maxLongitude) / 2);
    }

    get area(): number {
        return (this.maxLatitude - this.minLatitude) * (this.maxLongitude - this.minLongitude);
    }

    containsPoint(point: GeoPoint): boolean {
        return point.latitude >= this.minLatitude && point.latitude <= this.maxLatitude
            && point.longitude >= this.minLongitude && point.longitude <= this.maxLongitude;
    }

    static fromPoints(points: GeoPoint[]): GeoBoundingBox {
        let minLatitude = _.minBy(points, it => it.latitude)!.latitude;
        let maxLatitude = _.maxBy(points, it => it.latitude)!.latitude;
        let minLongitude = _.minBy(points, it => it.longitude)!.longitude;
        let maxLongitude = _.maxBy(points, it => it.longitude)!.longitude;
        return new GeoBoundingBox(minLatitude, maxLatitude, minLongitude, maxLongitude);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/geoBoundingBox.ts